import React from 'react';
import { Alert, Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Snackbar, TextField, Typography } from '@mui/material';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import SaveIcon from '@mui/icons-material/Save';
import { useCreateUserForm } from '../hooks/useCreateUserForm';
import { PROFESIONES, ROLES, getRoleLabel } from '../model/userConstants';
import { usePermissions } from '../../../shared/auth/PermissionsContext';

const inputSx = { '& .MuiOutlinedInput-root': { borderRadius: 2 } };

export default function CreateUserForm({ user, onSuccess, onCancel }) {
  const {
    isEdit,
    nombre, setNombre, apellidos, setApellidos, usuario, setUsuario, email, setEmail, password, setPassword, profesional, setProfesional,
    role, setRole, openGood, setOpenGood, openBad, setOpenBad, errors, handleSave,
  } = useCreateUserForm({ user, onSuccess });
  const { hasPermission } = usePermissions();
  const canManageAdmins = hasPermission('users:manage_admins');

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}><TextField label="Nombre" required fullWidth error={!!errors.nombre} helperText={errors.nombre} value={nombre} onChange={(e) => setNombre(e.target.value)} sx={inputSx} /></Grid>
        <Grid item xs={12} md={6}><TextField label="Apellidos" required fullWidth error={!!errors.apellidos} helperText={errors.apellidos} value={apellidos} onChange={(e) => setApellidos(e.target.value)} sx={inputSx} /></Grid>
        <Grid item xs={12} md={6}><TextField label="Usuario" required fullWidth error={!!errors.usuario} helperText={errors.usuario} value={usuario} onChange={(e) => setUsuario(e.target.value)} sx={inputSx} /></Grid>
        <Grid item xs={12} md={6}><TextField label="Email" required fullWidth error={!!errors.email} helperText={errors.email} value={email} onChange={(e) => setEmail(e.target.value)} sx={inputSx} /></Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Contraseña"
            type="password"
            required={!isEdit}
            fullWidth
            error={!!errors.password}
            helperText={errors.password || (isEdit ? 'Déjala en blanco para no cambiarla' : '')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={inputSx}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel>Profesión</InputLabel>
            <Select value={profesional} label="Profesión" onChange={(e) => setProfesional(e.target.value)} sx={inputSx}>
              {Object.keys(PROFESIONES).map((label) => (
                <MenuItem key={label} value={label}>{label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {isEdit ? (
          <Grid item xs={12}>
            <Typography variant="caption" sx={{ color: '#6b7280' }}>
              Rol actual: <strong>{getRoleLabel(role)}</strong>. Para cambiarlo, usa el botón "Permisos" del usuario.
            </Typography>
          </Grid>
        ) : (
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Rol</InputLabel>
              <Select value={role} label="Rol" disabled={!canManageAdmins && role === 'SANITARIO'} onChange={(e) => setRole(e.target.value)} sx={inputSx}>
                <MenuItem value="SANITARIO">{getRoleLabel('SANITARIO')}</MenuItem>
                {canManageAdmins ? Object.keys(ROLES).filter((r) => r !== 'SANITARIO').map((r) => (
                  <MenuItem key={r} value={r}>{getRoleLabel(r)}</MenuItem>
                )) : null}
              </Select>
            </FormControl>
          </Grid>
        )}
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: 4 }}>
        {onCancel ? (
          <Button onClick={onCancel} sx={{ borderRadius: 2 }}>Cancelar</Button>
        ) : null}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          startIcon={isEdit ? <SaveIcon /> : <PersonAddAlt1Icon />}
          sx={{ px: 3, py: 1.25, borderRadius: 2 }}
        >
          {isEdit ? 'Guardar cambios' : 'Crear usuario'}
        </Button>
      </Box>
      <Snackbar open={openGood} autoHideDuration={2000} onClose={() => setOpenGood(false)}>
        <Alert severity="success" onClose={() => setOpenGood(false)}>{isEdit ? 'Usuario actualizado correctamente.' : 'Usuario creado correctamente.'}</Alert>
      </Snackbar>
      <Snackbar open={openBad} autoHideDuration={2000} onClose={() => setOpenBad(false)}><Alert severity="error" onClose={() => setOpenBad(false)}>Revisa los datos del formulario.</Alert></Snackbar>
    </Box>
  );
}
